import { createFileRoute } from '@tanstack/react-router'

import { AttachmentPage } from '@/pages/AttachmentPage'

export const Route = createFileRoute(
  '/_authenticated/attachments/$inquiryMessageAttachmentUid/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { inquiryMessageAttachmentUid } = Route.useParams()

  return (
    <AttachmentPage inquiryMessageAttachmentUid={inquiryMessageAttachmentUid} />
  )
}
